import React from 'react';
import { Divider, makeStyles } from '@rbx/ui';

const useReferenceDividerStyles = makeStyles()(() => ({
  dividerSpacing: {
    marginTop: '36px',
    marginBottom: '36px',
  },
  divider: {
    borderBottomWidth: '3px',
  },
}));

const ReferenceDivider = () => {
  const { classes } = useReferenceDividerStyles();
  return (
    <div className={classes.dividerSpacing}>
      <Divider className={classes.divider} />
    </div>
  );
};

export default ReferenceDivider;
